<template>
    <div class="pop-up-container" id="popup">
        <div class="main-box">
            <div class="close-box">
                <div class="close fr" @click="close()">
                    <i class="icon iconfont icon-guanbi"></i>
                </div>
            </div>
            <div class="main-info">
                <div class="bgimg">
                    <div class="title">{{data.title}}</div>
                    <div class="content">
                        <textarea name="con" id="con" readonly :value="data.data"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'popupP',
    props: ['data'],
    data() {
        return {}
    },
    mounted() {
        document.getElementById('popup').style.height = document.documentElement.clientHeight + 'px';
    },
    methods: {
        close() {
            this.$emit('pcPopupShow', false);
        }
    }
}
</script>
<style lang="scss" scoped>
@import './PopUpP.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/popup/PopUpP.vue